import React, { createContext, ReactNode, useContext } from 'react';

type TabsContextType = {
  activeTab: number;
  setActiveTab: (tab: number) => void;
};

const BuilderIoTabsContext = createContext<TabsContextType | undefined>(undefined);

type BuilderIoTabsProviderProps = {
  children: ReactNode;
  value?: { activeTab: any; setActiveTab: any };
};

export const BuilderIoTabsProvider: React.FC<BuilderIoTabsProviderProps> = ({ children, value }) => {
  return <BuilderIoTabsContext.Provider value={value}>{children}</BuilderIoTabsContext.Provider>;
};

export const useBuilderIoTabs = (): TabsContextType => {
  const context = useContext(BuilderIoTabsContext);
  if (!context) {
    console.error(
      'Builder.io "Tab content" component should be inside "Tab" component, and cant be used outside the "Tab"'
    );
    return {} as any;
  }
  return context;
};
